import { alpha, keyframes, type SxProps, type Theme } from '@mui/material/styles';
import { SIDE_PADDING } from '../AiChat/utils/consts.ts';

const glow = (theme: Theme) => {
  const color = theme.palette.primary.main;

  return keyframes({
    '0%': { boxShadow: `0 0 0 0 ${alpha(color, 0.6)}, 0 0 0 0 ${alpha(color, 0.3)}` },
    '50%': { boxShadow: `0 0 0 4px ${alpha(color, 0.25)}, 0 0 10px 3px ${alpha(color, 0.25)}` },
    '100%': { boxShadow: `0 0 0 9px ${alpha(color, 0)}, 0 0 14px 6px ${alpha(color, 0)}` },
  });
};

const bounce = keyframes({
  '0%, 100%': { transform: 'translateY(0)' },
  '50%': { transform: 'translateY(8px)' },
});

export const rootSx: SxProps<Theme> = {
  width: '100%',
  px: SIDE_PADDING,
  pt: 1,
  pb: 2,
};

// these are to indicate more deal results scrollable in the dropdown
const DEAL_OPTION_HEIGHT = 50;
const VISIBLE_DEAL_OPTIONS = 4.5;
const LISTBOX_PADDING_TOP = 8;

export const listboxSx: SxProps<Theme> = {
  maxHeight: DEAL_OPTION_HEIGHT * VISIBLE_DEAL_OPTIONS + LISTBOX_PADDING_TOP,
};

export const optionContentSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  py: 1,
  minWidth: 0,
  overflowWrap: 'anywhere',
};

// the design-system tooltip defaults to captionSm; the attention hint is a larger, standalone callout
export const hintSx: SxProps<Theme> = theme => ({
  ...theme.typography.body2,
  fontWeight: theme.typography.fontWeightMedium,
  px: 1.25,
  py: 0.75,
  animation: `${bounce} 1s ease-in-out infinite`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
});

export const autocompleteSx: SxProps<Theme> = theme => ({
  '& .MuiOutlinedInput-root': {
    animation: `${glow(theme)} 1.5s ease-out infinite`,
    '&.Mui-focused': { animation: 'none' },
    '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
  },
  '& .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
});
